/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-16 18:51:41
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-02-28 17:09:30
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Modal/ModalFooter.tsx
 */
import Button from '@/src/components/Antd/Button/Button';
import { getI18nFromGeneral } from '@/src/tools/tools';
import React from 'react';
import css from './Modal.less';

const ModalFooter = (props) => {
  const {
    frontCountTip,
    front,
    onDelete,
    onCancel,
    onOk,
    okText,
    cancelText,
    okClassName,
    danger,
    hideOkButton,
    loading,
    deleteText,
  } = props;

  return (
    <div className={css.footerContainer}>
      <div className={css.frontContainer}>
        {frontCountTip ? (
          <div className={css.footerTip}>{frontCountTip}</div>
        ) : (
          front || null
        )}
      </div>
      <div className={css.buttonsContainer}>
        {onDelete && (
          <Button
            danger
            ghost
            className={`${css.deleteBtn}`}
            data-test-id='modal_delete'
            onClick={onDelete}>
            {deleteText ||
              getI18nFromGeneral('general.antd.Modal.ModalFooter.delete')}
          </Button>
        )}
        {onCancel && (
          <Button onClick={onCancel} data-test-id='modal_cancel'>
            {cancelText ||
              getI18nFromGeneral('general.antd.Modal.ModalFooter.cancel')}
          </Button>
        )}
        {onOk && (
          <Button
            type='primary'
            data-test-id='modal_confirm'
            danger={danger}
            disabled={hideOkButton}
            loading={loading}
            onClick={onOk}
            className={`${css.confirmBtn} ${okClassName || ''}`}>
            {okText ||
              getI18nFromGeneral('general.antd.Modal.ModalFooter.confirm')}
          </Button>
        )}
      </div>
    </div>
  );
};
export default ModalFooter;
